module.exports = __webpack_public_path__ + "static/scale-model-of-pier-39-sea-lions-in-berkeley-california-a0227574b91bf5bb810fd6d24b01f6e7.png";